import RouteConstants from '@/features/router/RouteConstants';
import { AudiencesIcon, CampaignIcon, DataSourcesIcon, DestinationsIcon, HomeIcon, SettingsIcon, UnifiedProfilesIcon } from '@/lib/Icons';
import { NavSidebarItemData } from './components/SidebarBase/SidebarNavigation/Items/NavSidebarItem/types';

export const SIDEBAR_CONFIG: ReadonlyArray<NavSidebarItemData> = [
  {
    icon: HomeIcon,
    path: RouteConstants.home,
    title: 'home',
  },
  {
    icon: CampaignIcon,
    path: RouteConstants.campaigns,
    title: 'campaign_other',
  },
  {
    icon: DataSourcesIcon,
    path: RouteConstants.dataSources,
    title: 'dataSource_other',
  },
  {
    icon: AudiencesIcon,
    path: RouteConstants.audiences,
    title: 'audience_other',
  },
  {
    icon: DestinationsIcon,
    path: RouteConstants.destinations,
    title: 'destination_other',
  },
  {
    icon: UnifiedProfilesIcon,
    path: RouteConstants.unifiedProfiles,
    title: 'unifiedProfile_other',
  }
] as const;
